<template>
  <div class="main-body">
    <div class="header">评估列表</div>
    <div class="out">

      <div class="search2">
        <el-button type="primary" size="mini" @click.native="showSelectElderly">添加</el-button>

        <div style="float:right;">

          <el-select v-model="institutionCode" placeholder="请选择机构">
            <el-option
                v-for="item in arr_ins"
                :key="item.institutionCode"
                :label="item.userName"
                :value="item.institutionCode">
            </el-option>
          </el-select>

          <el-button size="mini" style="margin-left:10px;float:right" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>

        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>

        <el-table-column type="expand" v-if="tableData.length">
          <template slot-scope="props">
            <el-form label-position="left" class="demo-table-expand">
              <el-form-item style="display: block;margin: 0px;" :label="value.checkinAssessGroupName+':'" v-for="(value,i) in props.row.listElderlyCheckinAssessItem" :key="i" >
                <div>{{value.checkinAssessItemName}}(得{{value.fraction}}分)</div>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>

        <el-table-column prop="elderlyName" label="残疾人姓名"></el-table-column>
        <el-table-column prop="checkinAssessClassName" label="评估分类"></el-table-column>
        <el-table-column prop="fraction" label="总分"></el-table-column>
        <el-table-column prop="createTime" :formatter="timefilter" label="创建时间"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"></Info>

    <SelectElderly ref="mySelectElderly" v-bind:arr_ins="arr_ins" v-show="showModalSelectElderly" v-on:closeSelectElderly="closeSelectElderly" v-on:getList="getList"></SelectElderly>


  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Info from "../Ins/Info";
import SelectElderly from "./SelectElderly";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalInfo:false,
      showModalSelectElderly:false,

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      th:0,

      arr_ins:[],
      institutionCode: '',

      type:1,

    }
  },
  components:{
    Info,SelectElderly
  },
  created(){
    this.getIns();

    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{


    getIns(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Institution/ListType",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          type:this.type,
        }
      }).then((response) => {

        if (response.data.error === 0) {
          this.arr_ins = response.data.data.list;
          if(this.arr_ins.length>0){
            this.institutionCode = this.arr_ins[0].institutionCode;
            this.getList();
          }
        }else if(response.data.error === 1){
          this.$message.error(response.data.message)
        }

      })

    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },


    showSelectElderly:function(){
      this.showModalSelectElderly = !this.showModalSelectElderly;
      this.$refs.mySelectElderly.init(this.type);
    },
    closeSelectElderly:function(){
      this.showModalSelectElderly = !this.showModalSelectElderly;
    },


    handleInfo(value) {
      this.$refs.myInfo.init(value);
      this.showModalInfo = !this.showModalInfo;
    },
    closeInfo:function(){
      this.showModalInfo = !this.showModalInfo;
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){

      this.loading = true;

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"ElderlyCheckinAssess/GovPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          institutionCode:this.institutionCode,
        }
      }).then( (response)=> {
        //console.log(response);
        this.loading = false;

        if(response.data.error == 0){
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        }else if(response.data.error == 1){
          this.$message({type: 'info', message: response.data.message});
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    handleDelete(index,row){
      this.$confirm('确定删除此评估吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        this.$axios({
          method: 'post',
          url: this.$shopUrl+"ElderlyCheckinAssess/Delete",
          data: {
            sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
            timeStr:timeStr,
            elderlyCheckinAssessCode:row.elderlyCheckinAssessCode,
          }
        }).then((response) => {
          if (response.data.error == 0) {
            this.getList();
          }else if(response.data.error == 1){
            this.$message.error(response.data.message)
          }
        })

      }).catch(() => {
        //this.$message({type: 'info', message: '已取消删除'});
      });
    },


  }
}
</script>
<style lang="scss" scoped>

.ElderlyCheckinAssess{
  .demo-table-expand /deep/ label {
    display: inline;
    color: #99a9bf;
  }

  .demo-table-expand /deep/ .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
}
</style>
